import React, { useState } from 'react';
import Image from 'next/image';

import Checkers from '../../../../../../helpers/class/Checkers';
import CustomModal from '../../../../../CustomModal';
import ModalServices from '../../modals/ModalServices';

export const Included = ( props ) => {
  const is_modal = () => Checkers.objChildExists( props, 'modal' );

  const [ showModal, setShowModal ] = useState( false );

  const handleHide = () => {
    setShowModal( prev => !prev );
  }

  const service = props.service;
  return (
    <>
      <div className="col-6 thumbnail-wrapper bordered b-grey b-rad-sm pull-left"
        style={{ width: 120, height: 120, marginRight: 10 }}
      >

        {
          Checkers.isValidArray( service.service_images ) && Checkers.isValidString( service.service_images[0].service_image_square_thumb ) &&
                    <Image
                      layout={'fixed'}
                      width={112}
                      height={112}
                      src={service.service_images[0].service_image_square_thumb}
                      alt={service.service_images[0].service_image_caption ? Checkers.removeEmojis(service.service_images[0].service_image_caption) : 'service-image-' + service.service_id}
                    />
        }
      </div>
      <div className="card-body pt-3 px-2 pb-0 text-left">
        {/*<div className="d-flex flex-column col-6 bold no-margin small text-left justify-content-center">*/}
        {
          !Checkers.isValidString( service.service_description ) ?
            Checkers.isValidString( service.service_title ) &&
                            <p>
                              <span className="text-master">{service.service_title}</span>
                            </p>
            :
            <p>
              <span className="text-master">
                {
                  Checkers.isValidString( service.service_title ) &&
                                service.service_title
                }
              </span>
              <br/>

              <span className="notes hint-text small">{service.service_description}</span>
            </p>
        }
      </div>
      {
        is_modal && showModal &&
                <CustomModal
                  modalName={'service-'+service.service_id}
                  className="slide_right"
                  modalSize="lg"
                  closeModal={() => {
                    handleHide()
                  }}
                  show={showModal}
                  Title={
                    <>
                      <h2 className="text-wrap text-left mt-0">{service.service_title}</h2>
                      {
                        Checkers.isValidString( service.service_description ) &&
                                <p className="hint-text text-left">
                                  {service.service_description}
                                </p>
                      }
                    </>
                  }
                >
                  <ModalServices service={props.service}/>
                </CustomModal>
      }
    </>
  )
}

export default Included;
